import createAxios from 'config/axios'

const URL = '/resources/v2/addresses/postal-code/{POSTAL_CODE}'

const getPostalCodeInfo = postalCode => createAxios.get(URL.replace('{POSTAL_CODE}', postalCode))

export default getPostalCodeInfo
